import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

export function initMasonry() {
  const grid = document.getElementById('masonry');
  if (!grid) return;

  const msnry = new Masonry(grid, {
    itemSelector: '.grid-item',
    columnWidth: '.grid-sizer',
    gutter: '.gutter-sizer',
    percentPosition: true
  });

  const imgLoad = imagesLoaded(grid);
  imgLoad.on('progress', function() {
    msnry.layout();
  });
}
